<template>
    <b-modal
        id="maintenance-mode-modal"
        :title="title"
        title-tag="h2"
        body-class="pt-0 pb-4"
        hide-footer
        dialog-class="maintenance-mode-modal"
    >
        <div class="mb-3 text-center">
            {{ message }}
        </div>

        <b-form-row class="justify-content-end">
            <b-col cols="auto">
                <b-button
                    variant="primary"
                    size="lg"
                    @click="$bvModal.hide('maintenance-mode-modal')"
                >
                    Ok
                </b-button>
            </b-col>
        </b-form-row>
    </b-modal>
</template>

<script>
export default {
    name: "MaintenanceMode",
    props: {
        title: {
            type: String,
            default: 'Thanks for submitting your form!'
        },
        message: {
            type: String,
            default: 'Please check back in a few minutes for your completed PDF.'
        }
    },
    data: () => ({}),
}
</script>